const __boundRoots = new WeakSet();
let __escBound = false;

export function caseFunc() {
  document.querySelectorAll('.js-case, .c-case').forEach((root) => {
    if (!root || __boundRoots.has(root)) return;
    __boundRoots.add(root);

    const html = document.documentElement;

    function portalize(popup) {
      if (popup.__portal) return;
      popup.__portal = { parent: popup.parentNode, next: popup.nextSibling };
      document.body.appendChild(popup);

      popup.__onClick = (e) => {
        if (e.target.closest('.c-case__popup__close')) {
          e.preventDefault?.();
          close(popup);
          return;
        }
        if (!e.target.closest('.c-case__popup__content')) {
          close(popup);
        }
      };
      popup.addEventListener('click', popup.__onClick);
    }

    function deportalize(popup) {
      if (!popup.__portal) return;
      popup.removeEventListener('click', popup.__onClick);
      popup.__onClick = null;

      const { parent, next } = popup.__portal;
      if (parent) {
        if (next && next.parentNode === parent) parent.insertBefore(popup, next);
        else parent.appendChild(popup);
      }
      popup.__portal = null;
    }

    function open(popup, trigger) {
      document.querySelectorAll('.c-case__popup.is-open').forEach(p => p !== popup && close(p, false));

      portalize(popup);

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      if (!popup.hasAttribute('role')) popup.setAttribute('role', 'dialog');
      if (!popup.hasAttribute('aria-modal')) popup.setAttribute('aria-modal', 'true');
      html.classList.add('is-locked');

      const closeBtn = popup.querySelector('.c-case__popup__close');
      if (closeBtn) {
        closeBtn.focus?.({ preventScroll: true });
      } else {
        const content = popup.querySelector('.c-case__popup__content');
        if (content && !content.hasAttribute('tabindex')) content.setAttribute('tabindex', '-1');
        content?.focus?.({ preventScroll: true });
      }

      popup.__returnFocus = trigger || null;
    }

    function close(popup, restoreFocus = true) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');

      deportalize(popup);

      if (!document.querySelector('.c-case__popup.is-open')) {
        html.classList.remove('is-locked');
      }
      if (restoreFocus && popup.__returnFocus) {
        try { popup.__returnFocus.focus(); } catch {}
        popup.__returnFocus = null;
      }
    }

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.c-case-btn');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      const popup = btn.closest('.c-case__item')?.querySelector('.c-case__popup');
      if (popup) open(popup, btn);
    });

    if (!__escBound) {
      __escBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const opened = document.querySelector('.c-case__popup.is-open');
        if (opened) close(opened);
      });
    }
  });
}
